import { ContinuousDrillingObligationTriggerBase } from './base/continuous-drilling-obligation-trigger-base';

export class ContinuousDrillingObligationTrigger extends ContinuousDrillingObligationTriggerBase { }